export default __webpack_public_path__ + "static/media/empower.7c025280.png";